module.exports = __webpack_public_path__ + "img/skating_clear_ice.f71ccddc.jpg";